<div class="row">
  <div class="col s12">
    <h4 class="h4 chart-title chart-title--thin margin-none">
      {{ 'groups.dashboard.lastFinishedStudents' | translate }}
      <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
    </h4>
  </div>
</div>
<div class="gl-table__container">
  <gl-table [dataSource]="dataSource" data-testid="dashboardTable" [placeholder]="'actions.noResultTable' | translate">
  </gl-table>
</div>
